import styled from 'styled-components';

import ButtonGoActive from '../../buttons/ButtonGoActive';
import { CloseButton } from '../../sharedStyledComponents/Components';

export const GoButton = styled(ButtonGoActive)`
  position: absolute;
  top: 393;
  left: 387;
`;

export const Background = styled.img`
  position: absolute;
  width: 472;
  height: 330;
  top: 112;
  left: 276;
`;

export const HeaderText = styled.h2`
  margin: 0;
  text-align: center;
  font-size: 27;
  font-family: Quicksand Bold;
  color: #ffffff;
  position: absolute;
  width: 150;
  height: 34;
  top: 131;
  left: 437;
`;

export const VocabFrequencyScanning = styled.p`
  margin: 0;
  position: absolute;
  top: 347;
  left: 368;
  width: 300;
  height: 28;
  font-family: Open Sans Bold;
  font-size: 21;
  text-align: center;
  color: #ffffff;
`;

export const CloseModalButton = styled(CloseButton)`
  position: absolute;
  top: 128;
  left: 717;
`;

export const Decoline = styled.img`
  position: absolute;
  width: 352;
  height: 15;
  top: 315;
  left: 336;
`;

export const VocabGuy = styled.img`
  position: absolute;
  width: 75;
  height: 74;
  top: 218;
  left: 475;
`;

export const Wave = styled.img`
  position: absolute;
  width: 450;
  height: 270;
  top: 149;
  left: 287;
`;
